import axios from 'axios'

export default axios.create({
    baseURL : "https://farmapi.porichorja.org/api"
})